import React from "react";
import { FiDownload, FiGithub, FiLinkedin } from "react-icons/fi";

function ResumeModule() {
  return (
    <section className="ops-section" id="resume">
      <div className="section-heading">
        <p>Download Module</p>
        <h2>Secure file transfer panel</h2>
      </div>
      <div className="resume-panel glass-panel">
        <div>
          <p className="system-path">/public/profile/resume</p>
          <h3>Edwin Resume DEC25.pdf</h3>
          <div className="file-meta">
            <span>File type: PDF</span>
            <span>Status: Ready</span>
            <span>Clearance: Public</span>
          </div>
        </div>
        <div className="resume-actions">
          <a href="/Edwin-Arzu-Resume.pdf" download><FiDownload /> Download Resume</a>
          <a href="https://www.linkedin.com/in/edwin-arzu-9b02b016a/" target="_blank" rel="noreferrer"><FiLinkedin /> View LinkedIn</a>
          <a href="https://github.com/Senqxi" target="_blank" rel="noreferrer"><FiGithub /> View GitHub</a>
        </div>
      </div>
    </section>
  );
}

export default ResumeModule;
